/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { useSelector } from "react-redux";

import get from "lodash/get";

export const PageIntroduction = Component => props => {
  const pageType = useSelector(state => get(state, ["qt", "pageType"]), "");

  const supportedPages = {
    "tag-page": "tag",
    "author-page": "author",
    "authors-page": "authors",
    "": ""
  };
  const theme = useSelector(state =>
    get(state, ["qt", "config", "pagebuilder-config", supportedPages[pageType], "pageSetting", "bgColor"], "")
  );

  const { config: authorsPageConfig = {}, layout = "" } = get(props, ["collection", "associated-metadata"], {});
  let updatedConfig = {
    theme,
    ...authorsPageConfig
  };

  const data = get(props, ["collection", "props"], {});
  const updateStyle = layout === "ArrowAuthorPageIntroductionCard" ? "unset" : "";
  return (
    <div className="component-wrapper" style={{ overflow: updateStyle }}>
      <Component data={data} config={updatedConfig} />
    </div>
  );
};
